import { render, staticRenderFns } from "./CancelReason.vue?vue&type=template&id=507a327c&scoped=true&"
import script from "./CancelReason.vue?vue&type=script&lang=js&"
export * from "./CancelReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507a327c",
  null
  
)

export default component.exports